import {ColorDecorator} from '@github-ui/shared-single-select-components/ColorDecorator'

import type {PersistedOption} from '../../../../api/columns/contracts/single-select'
import type {FieldAggregate} from '../../../../hooks/use-aggregation-settings'
import {SanitizedHtml} from '../../../dom/sanitized-html'
import {AggregateLabels} from '../../aggregate-labels'
import {SanitizedGroupHeaderText} from '../sanitized-group-header-text'
import styles from './single-select-group-header-label.module.css'

type Props = {
  option: PersistedOption
  rowCount: number
  hideItemsCount: boolean
  aggregates: Array<FieldAggregate>
  titleClassName?: string
}

export const SingleSelectGroupHeaderLabel = ({option, rowCount, aggregates, hideItemsCount, titleClassName}: Props) => (
  <>
    <ColorDecorator color={option.color} />

    <SanitizedGroupHeaderText titleHtml={option.nameHtml} className={titleClassName} />
    <AggregateLabels
      itemsCount={rowCount}
      aggregates={aggregates}
      hideItemsCount={hideItemsCount}
      counterClassName={styles.AggregateLabels}
    />
    {option.descriptionHtml && <SanitizedHtml className={styles.SanitizedHtml}>{option.descriptionHtml}</SanitizedHtml>}
  </>
)
